// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__2uJpm"};